<template name="websocket">
  <div>
    <el-dialog title="提示" :visible.sync="show_tip" width="30%">
      <span>{{player_name}}邀请您对弈，是否同意？</span>
      <span>等级:{{player_level}} 获胜:{{player_win_count}}场</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="join_game('reject')">拒 绝</el-button>
        <el-button type="primary" @click="join_game('ok')">同 意</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="show_tip_ww" width="30%">
      <span>您有一盘棋未下完，要继续吗？</span>
      <span>等级:{{player_level}} 获胜:{{player_win_count}}场</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="join_game_ww('reject')">认 输</el-button>
        <el-button type="primary" @click="join_game_ww('ok')">继 续</el-button>
      </span>
    </el-dialog>
    <!--提示对话框-->
    <!-- <view v-if="show_tip" :class="['ruleZhezhao']">
      <view
        class="ruleZhezhaoContent confirm yaoqing-view"
        :style="'margin:' + (sysInfo.bigSize?'8%':'30%') + ' auto;'"
      >
        <text>{{player_name}}邀请您对弈，是否同意？</text>
        <text
          style="display: inline-block;margin-top: -16%;"
        >等级:{{player_level}} 获胜:{{player_win_count}}场</text>
        <view class="img-button">
          <image
            @click="join_game('reject')"
            mode="aspectFit"
            :src="sysInfo.filePath + 'images/duiyi/jujue.' + sysInfo.ext"
          />
          <image
            @click="join_game('ok')"
            mode="aspectFit"
            :src="sysInfo.filePath + 'images/duiyi/jieshou.' + sysInfo.ext"
          />
        </view>
      </view>
    </view>-->
    <!--提示对话框-->
    <!-- <view v-else-if="show_tip_ww" :class="['ruleZhezhao']">
      <view
        class="ruleZhezhaoContent confirm yaoqing-view"
        :style="'margin:' + (sysInfo.bigSize?'20%':'60%') + ' auto;'"
      >
        <text>您有一盘棋未下完，要继续吗？</text>
        <view class="img-button">
          <image
            @click="join_game_ww('reject')"
            mode="aspectFit"
            :src="sysInfo.filePath + 'images/duiyi/fou.' + sysInfo.ext"
          />
          <image
            @click="join_game_ww('ok')"
            mode="aspectFit"
            :src="sysInfo.filePath + 'images/duiyi/shi.' + sysInfo.ext"
          />
        </view>
      </view>
    </view>-->
  </div>
</template>

<script>
import Ws from "@/common/websocket.js";
import globalData from "@/common/global.js";
export default {
  name: "websocket",
  props: {
    userInfo: {
      type: Object,
      default: globalData.userInfo
    },
    /*old_game: {
      type: Object,
      default: null
	},*/
    page: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      sysInfo: globalData.sysInfo,
      ws: null,
      duiyi_picker: {
        index: 0,
        array: []
      },
      bannerShow: false,
      bannerShow_pipei: false,
      pipei_djs: 60,
      game_time: 5,
      b_size: 19,
      show_tip: false,
      //show_tip2:false,
      show_tip_ww: false,
      player_name: "",
      player_level: 0,
      player_win_count: 0,
      player_id: 0,
      yaoqing_list: [],
      yq_djs: 0
    };
  },
  mounted() {
    let self = this;
    //if (globalData.ws==null) globalData.ws = Ws.getWebSocket()
    this.ws = globalData.ws;
    this.ws.onMessage("component_ws", res => {
      res = JSON.parse(res.data);
      switch (res.event) {
        case "begin_game":
          localStorage.rev_color = res.color;
          //uni.setStorageSync('rev_color',res.color)
          localStorage.game = JSON.stringify({
            game_id: res.game_id,
            color: res.color,
            b_size: this.b_size,
            game_time: this.game_time
          });
          //uni.setStorageSync('game',{game_id:res.game_id,color:res.color,b_size:this.b_size,game_time:this.game_time})
          //删除定时器
          clearInterval(this.pp_djs);
          this.page.yaoqing_win = false
          this.$router.push({
            path: "/duiju",
            query: {
              game_id: res.game_id,
              self_color: res.color,
              first_step: res.first_step,
              game_time: this.game_time,
              b_size: this.b_size
            }
          });
          /*uni.redirectTo({
							url:'../duiju/duiju?game_id='+res.game_id+'&self_color='+res.color+'&first_step='+res.first_step+'&game_time='+this.game_time+'&b_size='+this.b_size
						})*/
          break;
        case "yaoqing":
          if (this.show_tip == true) {
            this.yaoqing_list.push(res);
          } else {
            this.chuli_yaoqing(res);
          }

          /*this.ws.send({
							event:'re_yaoqing',
							ids:[res.user.id,this.userInfo.id],
							b_size:this.b_size,
							game_time:this.game_time
						})*/

          break;
        case "re_yaoqing":
          //this.show_tip2 = false
          if (this.page && this.page.yaoqing_win) this.page.yaoqing_win = false;
          this.$message.info("对方拒绝了您的邀请");
          /*uni.showToast({
							title: '对方拒绝了您的邀请',
							mask: false,
							duration: 3000,
							icon:'none'
						});*/
          /*setTimeout(function(){
							if(self.yaoqing_list[0]) {
								let res = self.yaoqing_list[0]
								self.yaoqing_list.splice(0,1)
								self.chuli_yaoqing(res)
							}
						},3000)*/
          break;
        case "game_exist":
          if (res.status == 0) {
            this.show_tip_ww = true;
          } else {
            localStorage.game = null;
            //uni.setStorageSync('game',null)
          }
          break;
        case "yaoqing_stop":
          clearInterval(this.yq_djs);
          this.show_tip = false;
          break;
        default:
      }
    });
    /*setTimeout(()=>{
				this.ws.send({
					event:'join_pool',
					user:{
						id:this.userInfo.id,
						duiyi_level:this.userInfo.duiyi_level,
						need_pipei:0,
						name:this.userInfo.name,
						wait:0,
						reject_list:[]
					},
					rev_color:globalData.rev_color,
					game_time:this.game_time,
					b_size:this.b_size
				})
			},2000)*/
  },
  methods: {
    join_game_ww(res) {
      this.old_game = JSON.parse(localStorage.game);
      if (res == "ok") {
        this.$router.push({
          path: "/duiju",
          query: {
            game_id: this.old_game.game_id,
            self_color: this.old_game.color,
            first_step: 0,
            game_time: this.old_game.game_time,
            b_size: this.old_game.b_size,
            type: "reconn"
          }
        });
        this.show_tip_ww = false;
        /*uni.redirectTo({
						url:'../duiju/duiju?game_id='+this.old_game.game_id+'&self_color='+this.old_game.color+'&first_step=0&game_time='+this.old_game.game_time+'&b_size='+this.old_game.b_size+'&type=reconn'
					})*/
      } else {
        this.ws.send({
          event: "region",
          game_id: this.old_game.game_id,
          color: this.old_game.color
        });
        localStorage.game = null;
        //uni.setStorageSync('game',null)
        this.old_game = null;
        this.show_tip_ww = false;
      }
    },
    duiyi_level_mapping(level) {
      level = parseInt(level);
      if (25 - level > 0) {
        return 25 - level + 1 + "级";
      } else {
        return level - 25 + "段";
      }
    },
    chuli_yaoqing(res) {
      this.player_name = res.user.name;
      this.player_id = res.user.id;
      this.player_level = this.duiyi_level_mapping(res.user.duiyi_level);
      this.player_win_count = res.user.win_count;
      this.show_tip = true;
      this.yq_djs = setTimeout(() => {
        this.show_tip = false;
        // this.ws.send({
        // 	event:'re_yaoqing',
        // 	res:'reject',
        // 	ids:[this.player_id,this.userInfo.id],
        // 	b_size:this.b_size,
        // 	game_time:this.game_time
        // })
      }, 20000);
    },
    reject_yaoqing_list() {
      for (let i in this.yaoqing_list) {
        this.ws.send({
          event: "re_yaoqing",
          res: "reject",
          ids: [this.yaoqing_list[i].user.id, this.userInfo.id],
          b_size: this.b_size,
          game_time: this.game_time
        });
      }
    },
    join_game(res) {
      clearTimeout(this.yq_djs);
      this.ws.send({
        event: "re_yaoqing",
        res: res,
        ids: [this.player_id, this.userInfo.id],
        b_size: this.b_size,
        game_time: this.game_time
      });
      this.show_tip = false;
      if (this.yaoqing_list[0] && res != "ok") {
        let res = this.yaoqing_list[0];
        this.yaoqing_list.splice(0, 1);
        this.chuli_yaoqing(res);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.yaoqing-view {
  height: 400upx;
}
.confirm {
  .wait-text {
    font-size: 50upx;
  }
  text {
    width: 88%;
    margin-top: 30upx;
    text-align: center;
  }
  .img-button {
    width: 80%;
    height: 93upx;
    margin-top: -50upx;
    image {
      width: 50%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/websocket.vue